(function () {
  var TOAST_DURATION_MS = 4000;
  var TOAST_FADE_MS = 350;
  var DETECT_DEBOUNCE_MS = 300;
  var TOAST_BOTTOM_GAP_PX = 8;
  var TOAST_DYNAMIC_BREAKPOINT = 850;
  var DESKTOP_LAYOUT_BREAKPOINT = 1000;
  var CART_DRAWER_SIDE_INSET_PX = 16;
  var CART_DRAWER_FOOTER_GAP_PX = 12;
  var GIFT_DATA_SELECTOR = '[data-pg-gift-items]';
  var DEBUG_FLAG_KEY = 'pgGiftToastDebug';

  var assets = window.PG_GIFT_TOAST_ASSETS || {};
  var DEBUG_ENABLED = false;

  try {
    DEBUG_ENABLED = localStorage.getItem(DEBUG_FLAG_KEY) === '1';
  } catch (e) {}

  function debugLog() {
    if (!DEBUG_ENABLED || !window.console || typeof console.log !== 'function') return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[PG Free Gift Toast]');
    console.log.apply(console, args);
  }

  // ─── Style injection ────────────────────────────────────────────────────────

  var styleInjected = false;
  function injectStyles() {
    if (styleInjected) return;
    styleInjected = true;
    var style = document.createElement('style');
    style.textContent = [
      '.pg-gt{position:fixed;z-index:2147483647;bottom:180px;left:16px;right:16px;box-sizing:border-box;max-width:calc(100vw - 32px);}',
      '@media(min-width:751px){.pg-gt{bottom:24px;left:auto;right:20px;width:min(400px,calc(100vw - 40px));max-width:400px;}}',
      '@media(min-width:1000px){',
        '.pg-gt{z-index:15;}',
        '.pg-gt__card{min-height:64px;}',
        '.pg-gt__img-wrap{width:48px;height:48px;}',
        '.pg-gt__img-wrap--lg{width:48px;height:48px;}',
        '.pg-gt__title{font-size:14px;line-height:1.35;}',
        '.pg-gt__card--multi .pg-gt__title{font-size:14px;}',
      '}',
      '.pg-gt{transform:translateY(16px);opacity:0;transition:transform ' + TOAST_FADE_MS + 'ms ease,opacity ' + TOAST_FADE_MS + 'ms ease;pointer-events:none;}',
      '.pg-gt--visible{transform:translateY(0);opacity:1;pointer-events:auto;cursor:pointer;}',
      '.pg-gt__card{position:relative;overflow:hidden;border-radius:8px;padding:8px 64px 8px 8px;',
        'background:linear-gradient(90deg,rgba(255,255,255,0.2) 0%,rgba(2,173,177,0.2) 153.77%),#fff;',
        'box-shadow:0px 0px 32px 0px rgba(0,0,0,0.2),1px 1px 1px 0px rgba(0,114,108,0.19),0px 0px 4px 0px rgba(0,0,0,0.17);',
        'display:flex;align-items:center;gap:8px;min-height:52px;}',
      '@media(min-width:751px){',
        '.pg-gt__card{padding:12px 76px 12px 12px;min-height:60px;gap:12px;border-radius:10px;}',
        '.pg-gt__img-wrap{border-radius:6px;}',
        '.pg-gt__sub{font-size:13px;}',
        '.pg-gt__card--multi{padding-right:80px;}',
        '.pg-gt__card--multi .pg-gt__sub{font-size:12px;}',
        '.pg-gt__glow{width:84px;height:84px;}',
      '}',
      '.pg-gt__img-wrap{background:#fff;border-radius:3.6px;width:36px;height:36px;',
        'flex-shrink:0;overflow:hidden;display:flex;align-items:center;justify-content:center;}',
      '.pg-gt__img{width:100%;height:100%;object-fit:cover;}',
      '.pg-gt__imgs-multi{display:flex;align-items:center;gap:0;flex-shrink:0;}',
      '.pg-gt__img-wrap--lg{width:40px;height:40px;position:relative;border:1px solid rgba(255,255,255,0.9);box-shadow:0 1px 3px rgba(0,0,0,0.12);}',
      '.pg-gt__imgs-multi .pg-gt__img-wrap--lg + .pg-gt__img-wrap--lg{margin-left:-32px;}',
      '.pg-gt__imgs-multi .pg-gt__img-wrap--lg:nth-child(1){z-index:1;}',
      '.pg-gt__imgs-multi .pg-gt__img-wrap--lg:nth-child(2){z-index:2;}',
      '.pg-gt__imgs-multi .pg-gt__img-wrap--lg:nth-child(3){z-index:3;}',
      '.pg-gt__card--multi{padding-right:72px;}',
      '.pg-gt__text{flex:1 1 0;min-width:0;}',
      '.pg-gt__title{font-size:13px;color:#1a1a1a;line-height:1.4;margin:0;font-weight:400;',
        'font-family:-apple-system,BlinkMacSystemFont,"SF Pro Text",sans-serif;}',
      '.pg-gt__title strong{font-weight:600;}',
      '.pg-gt__sub{font-size:12px;color:#696c75;letter-spacing:-0.022px;margin:0;line-height:1.4;',
        'font-family:-apple-system,BlinkMacSystemFont,"SF Pro Text",sans-serif;}',
      '.pg-gt__card--multi .pg-gt__title{font-size:12px;}',
      '.pg-gt__card--multi .pg-gt__sub{font-size:11px;}',
      '.pg-gt__deco{position:absolute;inset:0;pointer-events:none;}',
      '.pg-gt__wave{position:absolute;top:0;left:58.5%;width:52%;height:135%;object-fit:fill;}',
      '.pg-gt__glow{position:absolute;top:-6px;left:82%;width:77px;height:77px;opacity:0.7;}',
      '.pg-gt__sa1{position:absolute;width:8px;height:8px;top:20%;left:87%;}',
      '.pg-gt__sa2{position:absolute;width:7px;height:7px;top:55%;left:84%;}',
      '.pg-gt__sb1{position:absolute;width:6px;height:6px;top:45%;left:91%;}',
      '.pg-gt__sb2{position:absolute;width:5px;height:5px;top:28%;left:93%;}',
      '.pg-gt__card--multi .pg-gt__wave{left:55%;width:50%;height:140%;}',
      '.pg-gt__card--multi .pg-gt__glow{left:80%;top:-6px;}',
      '.pg-gt__card--multi .pg-gt__sa1{left:83%;top:20%;}',
      '.pg-gt__card--multi .pg-gt__sa2{left:80%;top:55%;}',
      '.pg-gt__card--multi .pg-gt__sb1{left:87%;top:45%;}',
      '.pg-gt__card--multi .pg-gt__sb2{left:89%;top:28%;}',
    ].join('');
    document.head.appendChild(style);
  }

  // ─── Helpers ─────────────────────────────────────────────────────────────────

  function escapeHTML(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getItemImage(item) {
    if (item.featured_image && item.featured_image.url) return item.featured_image.url;
    if (item.image) return item.image;
    return '';
  }

  function getItemTitle(item) {
    return item.product_title || item.title || 'Gift';
  }

  // ─── HTML builders ───────────────────────────────────────────────────────────

  function buildDecoHTML() {
    var wave = assets.wave
      ? '<img src="' + escapeHTML(assets.wave) + '" class="pg-gt__wave" alt="">'
      : '';
    var glow = assets.glow
      ? '<img src="' + escapeHTML(assets.glow) + '" class="pg-gt__glow" alt="">'
      : '';
    var sa = assets.sparkleA
      ? '<img src="' + escapeHTML(assets.sparkleA) + '" class="pg-gt__sa1" alt="">' +
        '<img src="' + escapeHTML(assets.sparkleA) + '" class="pg-gt__sa2" alt="">'
      : '';
    var sb = assets.sparkleB
      ? '<img src="' + escapeHTML(assets.sparkleB) + '" class="pg-gt__sb1" alt="">' +
        '<img src="' + escapeHTML(assets.sparkleB) + '" class="pg-gt__sb2" alt="">'
      : '';
    return '<div class="pg-gt__deco" aria-hidden="true">' + wave + glow + sa + sb + '</div>';
  }

  function buildImagesHTML(items) {
    if (items.length === 1) {
      var src = getItemImage(items[0]);
      return (
        '<div class="pg-gt__img-wrap">' +
        (src ? '<img src="' + escapeHTML(src) + '" class="pg-gt__img" alt="">' : '') +
        '</div>'
      );
    }
    var html = '<div class="pg-gt__imgs-multi">';
    var max = Math.min(items.length, 3);
    for (var i = 0; i < max; i++) {
      var imgSrc = getItemImage(items[i]);
      html +=
        '<div class="pg-gt__img-wrap pg-gt__img-wrap--lg">' +
        (imgSrc ? '<img src="' + escapeHTML(imgSrc) + '" class="pg-gt__img" alt="">' : '') +
        '</div>';
    }
    return html + '</div>';
  }

  function buildTitleHTML(items) {
    var count = items.length;
    if (count === 1) {
      return (
        '<strong>Yay! Free ' + escapeHTML(getItemTitle(items[0])) + ' </strong>Added to Cart'
      );
    }

    if (count === 2) {
      return (
        '<strong>Yay! Free ' + escapeHTML(getItemTitle(items[0])) + ' </strong>and ' +
        '<strong>' + escapeHTML(getItemTitle(items[1])) + ' </strong>Added to Cart'
      );
    }

    return (
      '<strong>Yay! Free ' + escapeHTML(getItemTitle(items[0])) + ' </strong>and ' +
      '<strong>' + (count - 1) + ' more </strong>Added to Cart'
    );
  }

  function buildToast(items) {
    var isMulti = items.length > 1;
    var cardClass = 'pg-gt__card' + (isMulti ? ' pg-gt__card--multi' : '');

    var el = document.createElement('div');
    el.className = 'pg-gt';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<div class="' + cardClass + '">' +
        buildImagesHTML(items) +
        '<div class="pg-gt__text">' +
          '<p class="pg-gt__title">' + buildTitleHTML(items) + '</p>' +
        '</div>' +
        buildDecoHTML() +
      '</div>';
    return el;
  }

  // ─── Toast display ──────────────────────────────────────────────────────────

  function openMiniCartDrawer() {
    var drawer = document.getElementById('mini-cart') || document.querySelector('cart-drawer.mini-cart');
    if (drawer) {
      drawer.setAttribute('open', '');
    }
  }

  function getRootBottomOffsetFromCSSVar() {
    try {
      var raw = window.getComputedStyle(document.documentElement).getPropertyValue('--cart-bottom-position');
      var parsed = parseFloat(raw);
      if (isNaN(parsed)) return 0;
      return Math.max(0, parsed);
    } catch (e) {
      return 0;
    }
  }

  function isLikelyFullscreenOverlay(rect, viewportHeight, viewportWidth) {
    if (!rect) return true;
    if (rect.width <= 0 || rect.height <= 0) return true;
    if (rect.height >= viewportHeight * 0.88 && rect.width >= viewportWidth * 0.88) return true;
    return false;
  }

  function getBottomIntervalForElement(el, viewportHeight, viewportWidth) {
    if (!el || !el.getBoundingClientRect) return null;
    var rect = el.getBoundingClientRect();
    if (isLikelyFullscreenOverlay(rect, viewportHeight, viewportWidth)) return null;
    if (rect.right <= 2 || rect.left >= viewportWidth - 2) return null;
    if (rect.bottom <= 2 || rect.top >= viewportHeight - 2) return null;

    return {
      top: Math.max(0, rect.top),
      bottom: Math.min(viewportHeight, rect.bottom)
    };
  }

  function getConnectedBottomStackInset(intervals, viewportHeight) {
    if (!intervals.length) return 0;

    var touchTolerance = 2;
    var componentTop = viewportHeight;
    var componentBottom = 0;

    for (var i = 0; i < intervals.length; i++) {
      if (intervals[i].bottom > componentBottom) componentBottom = intervals[i].bottom;
    }

    var changed = true;
    while (changed) {
      changed = false;
      for (var j = 0; j < intervals.length; j++) {
        var current = intervals[j];
        if (current.bottom < componentTop - touchTolerance) continue;
        if (current.top > componentBottom + touchTolerance) continue;

        if (current.top < componentTop) {
          componentTop = current.top;
          changed = true;
        }
        if (current.bottom > componentBottom) {
          componentBottom = current.bottom;
          changed = true;
        }
      }
    }

    // Ignore stacks not anchored to the viewport bottom.
    if (componentBottom < viewportHeight - 24) return 0;
    return Math.max(0, componentBottom - componentTop);
  }

  function getDynamicBottomInset() {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    if (!viewportHeight) return 0;

    var intervals = [];
    var fallbackInset = getRootBottomOffsetFromCSSVar();
    var selectors = [
      '.bottom-navbar',
      'product-sticky-form:not([hidden])',
      '.product-sticky-form:not([hidden])',
      '#cartPopup'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var nodes = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        var style = window.getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) continue;
        if (style.position !== 'fixed' && style.position !== 'sticky') continue;

        var interval = getBottomIntervalForElement(node, viewportHeight, viewportWidth);
        if (interval) intervals.push(interval);
      }
    }

    var stackInset = getConnectedBottomStackInset(intervals, viewportHeight);
    return Math.max(fallbackInset, stackInset);
  }

  function clearToastInlineLayout(toast) {
    ['bottom', 'right', 'left', 'width', 'max-width'].forEach(function (prop) {
      toast.style.removeProperty(prop);
    });
  }

  function applyToastLayout(toast) {
    if (!toast) return;

    var viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

    clearToastInlineLayout(toast);

    if (viewportWidth >= DESKTOP_LAYOUT_BREAKPOINT) {
      var drawer = document.getElementById('mini-cart');
      var isCartOpen = drawer && drawer.hasAttribute('open');

      if (isCartOpen) {
        var drawerRect = drawer.getBoundingClientRect();
        if (drawerRect.width > 0) {
          var footer = drawer.querySelector('.mini-cart__drawer-footer');
          var sideInset = CART_DRAWER_SIDE_INSET_PX;
          var toastWidth = Math.min(468, Math.max(300, Math.round(drawerRect.width - sideInset * 2)));

          toast.style.width = toastWidth + 'px';
          toast.style.maxWidth = toastWidth + 'px';
          toast.style.right = Math.max(sideInset, Math.round(viewportWidth - drawerRect.right + sideInset)) + 'px';
          toast.style.left = 'auto';

          if (footer) {
            var footerRect = footer.getBoundingClientRect();
            toast.style.bottom = Math.max(
              CART_DRAWER_FOOTER_GAP_PX,
              Math.round(viewportHeight - footerRect.top + CART_DRAWER_FOOTER_GAP_PX)
            ) + 'px';
          } else {
            toast.style.bottom = '24px';
          }
          return;
        }
      }

      toast.style.bottom = '24px';
      toast.style.right = '20px';
      toast.style.left = 'auto';
      toast.style.width = '400px';
      toast.style.maxWidth = '400px';
      return;
    }

    if (viewportWidth > TOAST_DYNAMIC_BREAKPOINT) {
      toast.style.bottom = '24px';
      toast.style.right = '20px';
      toast.style.left = 'auto';
      return;
    }

    var inset = getDynamicBottomInset();
    var offset = Math.max(TOAST_BOTTOM_GAP_PX, inset + TOAST_BOTTOM_GAP_PX);
    toast.style.bottom = 'calc(' + offset + 'px + env(safe-area-inset-bottom, 0px))';
    toast.style.left = '16px';
    toast.style.right = '16px';
  }

  function syncVisibleToastOffset() {
    applyToastLayout(document.querySelector('.pg-gt'));
  }

  function observeCartDrawerForToastLayout() {
    var drawer = document.getElementById('mini-cart');
    if (!drawer || drawer.__pgGiftToastLayoutObserver) return;

    drawer.__pgGiftToastLayoutObserver = true;
    var observer = new MutationObserver(function () {
      syncVisibleToastOffset();
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  function showFreeGiftToast(items) {
    if (!items || !items.length) return;
    debugLog('showFreeGiftToast()', items.map(function (item) { return item && item.key; }));
    injectStyles();

    var existing = document.querySelector('.pg-gt');
    if (existing) existing.remove();

    var toast = buildToast(items);
    toast.setAttribute('title', 'Open cart');
    toast.tabIndex = 0;

    document.body.appendChild(toast);
    applyToastLayout(toast);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        toast.classList.add('pg-gt--visible');
        applyToastLayout(toast);
      });
    });

    // Re-check after drawer/footer layout settles.
    setTimeout(function () {
      applyToastLayout(toast);
    }, 280);
    setTimeout(function () {
      applyToastLayout(toast);
    }, 600);

    var hideTimer = setTimeout(function () {
      toast.classList.remove('pg-gt--visible');
      setTimeout(function () {
        if (toast.parentNode) toast.remove();
      }, TOAST_FADE_MS);
    }, TOAST_DURATION_MS);

    function dismissToast() {
      clearTimeout(hideTimer);
      toast.classList.remove('pg-gt--visible');
      setTimeout(function () {
        if (toast.parentNode) toast.remove();
      }, TOAST_FADE_MS);
    }

    function onActivate() {
      openMiniCartDrawer();
      dismissToast();
    }

    toast.addEventListener('click', onActivate);

    toast.addEventListener('keydown', function (e) {
      var key = e.key;
      if (key === 'Enter' || key === ' ') {
        e.preventDefault();
        onActivate();
      }
    });
  }

  // ─── Detection via cart update events + Liquid gift data ───────────────────
  // Free-gift items are injected by Liquid into [data-pg-gift-items].
  // We seed baseline once on init, then react to cart events below.

  var previousGiftKeys = new Set();
  var hasSeededBaseline = false;
  var hasSeenCartSignal = false;
  var detectTimer = null;
  var previousExternalGiftNotifyHandler = null;
  var HANDLER_MARKER = '__pgGiftNotifyToastHandler';

  function normalizeGiftItems(items) {
    if (!Array.isArray(items)) return [];
    var byKey = {};
    for (var i = 0; i < items.length; i++) {
      var item = items[i] || {};
      var key = item.key ? String(item.key) : '';
      if (!key) continue;
      byKey[key] = item;
    }
    return Object.keys(byKey).map(function (key) { return byKey[key]; });
  }

  function detectNewGifts(items, shouldToast) {
    var normalizedItems = normalizeGiftItems(items);
    var currentKeys = new Set();

    for (var i = 0; i < normalizedItems.length; i++) {
      var itemKey = String(normalizedItems[i].key || '');
      if (itemKey) currentKeys.add(itemKey);
    }

    if (!hasSeededBaseline) {
      if (shouldToast && hasSeenCartSignal && normalizedItems.length > 0) {
        debugLog('First non-empty state after cart signal; firing initial toast', normalizedItems.map(function (item) {
          return item.key;
        }));
        showFreeGiftToast(normalizedItems);
      }
      previousGiftKeys = currentKeys;
      hasSeededBaseline = true;
      debugLog('Baseline seeded', Array.from(previousGiftKeys));
      return;
    }

    if (shouldToast) {
      var newItems = [];
      for (var j = 0; j < normalizedItems.length; j++) {
        var key = String(normalizedItems[j].key || '');
        if (!key || previousGiftKeys.has(key)) continue;
        newItems.push(normalizedItems[j]);
      }
      debugLog('Detect cycle', {
        previousKeys: Array.from(previousGiftKeys),
        currentKeys: Array.from(currentKeys),
        newKeys: newItems.map(function (item) { return item.key; })
      });
      if (newItems.length) showFreeGiftToast(newItems);
    }

    previousGiftKeys = currentKeys;
  }

  function resolveGiftDataElement() {
    var section = document.getElementById('shopify-section-mini-cart');
    if (section) {
      var sectionScripts = section.querySelectorAll(GIFT_DATA_SELECTOR);
      if (sectionScripts.length) return sectionScripts[sectionScripts.length - 1];
    }

    var drawer = document.getElementById('mini-cart');
    if (drawer) {
      var drawerScripts = drawer.querySelectorAll(GIFT_DATA_SELECTOR);
      if (drawerScripts.length) return drawerScripts[drawerScripts.length - 1];
    }

    var allScripts = document.querySelectorAll(GIFT_DATA_SELECTOR);
    if (!allScripts.length) return null;
    return allScripts[allScripts.length - 1];
  }

  function readGiftDataFromDOM() {
    var el = resolveGiftDataElement();
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function readGiftDataFromLineItems() {
    var root = document.getElementById('mini-cart') || document;
    var lineItems = root.querySelectorAll('line-item.free-gift_item');
    if (!lineItems.length) return [];

    var collected = [];
    for (var i = 0; i < lineItems.length; i++) {
      var lineItem = lineItems[i];
      var key = String(lineItem.getAttribute('data-line-key') || lineItem.getAttribute('data-line') || ('fg-' + i));
      var titleNode = lineItem.querySelector('.product-item-meta__title');
      var imageNode = lineItem.querySelector('.line-item__image');
      var imageUrl = imageNode && imageNode.getAttribute('src') ? imageNode.getAttribute('src') : '';

      collected.push({
        key: key,
        product_title: titleNode ? titleNode.textContent.trim() : 'Gift',
        image: imageUrl,
        featured_image: { url: imageUrl }
      });
    }

    return collected;
  }

  function processGiftData() {
    var items = readGiftDataFromDOM();
    if (items === null) {
      items = readGiftDataFromLineItems();
      debugLog('Using line-item fallback gift data', items);
    } else {
      debugLog('Liquid gift data seen', items);
      // If JSON block exists but is empty while drawer already has free gift lines,
      // trust rendered line items as a stronger source-of-truth for toast display.
      if (Array.isArray(items) && items.length === 0) {
        var fallbackItems = readGiftDataFromLineItems();
        if (fallbackItems.length) {
          items = fallbackItems;
          debugLog('Switched to line-item fallback due empty JSON', items);
        }
      }
    }
    detectNewGifts(items, true);
  }

  function mutationNodeTouchesMiniCart(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.id === 'mini-cart' || node.id === 'shopify-section-mini-cart') return true;
    if (node.matches && node.matches('#mini-cart, #shopify-section-mini-cart, [data-pg-gift-items], line-item.free-gift_item')) {
      return true;
    }
    if (node.closest && node.closest('#mini-cart, #shopify-section-mini-cart')) return true;
    if (node.querySelector && node.querySelector('#mini-cart, #shopify-section-mini-cart, [data-pg-gift-items], line-item.free-gift_item')) {
      return true;
    }
    return false;
  }

  function mutationTouchesGiftData(mutation) {
    if (!mutation) return false;
    if (mutationNodeTouchesMiniCart(mutation.target)) return true;

    var added = mutation.addedNodes || [];
    for (var i = 0; i < added.length; i++) {
      if (mutationNodeTouchesMiniCart(added[i])) return true;
    }

    var removed = mutation.removedNodes || [];
    for (var j = 0; j < removed.length; j++) {
      if (mutationNodeTouchesMiniCart(removed[j])) return true;
    }
    return false;
  }

  function observeGiftDataMutations() {
    var root = document.documentElement;
    if (!root || root.__pgGiftToastMutationObserver) return;
    root.__pgGiftToastMutationObserver = true;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (!mutationTouchesGiftData(mutations[i])) continue;
        hasSeenCartSignal = true;
        scheduleDetection(DETECT_DEBOUNCE_MS);
        return;
      }
    });

    observer.observe(root, {
      childList: true,
      subtree: true
    });
  }

  function registerGiftNotifyHandler() {
    if (
      typeof window.PG_GIFT_NOTIFY_HANDLER === 'function' &&
      !window.PG_GIFT_NOTIFY_HANDLER[HANDLER_MARKER]
    ) {
      previousExternalGiftNotifyHandler = window.PG_GIFT_NOTIFY_HANDLER;
    }

    var handler = function (newGiftItems) {
      var normalizedItems = normalizeGiftItems(newGiftItems);
      if (!normalizedItems.length) return;

      var mergedKeys = new Set(previousGiftKeys);
      for (var i = 0; i < normalizedItems.length; i++) {
        var key = String(normalizedItems[i].key || '');
        if (key) mergedKeys.add(key);
      }

      previousGiftKeys = mergedKeys;
      hasSeededBaseline = true;
      showFreeGiftToast(normalizedItems);

      if (typeof previousExternalGiftNotifyHandler === 'function') {
        previousExternalGiftNotifyHandler(normalizedItems);
      }
    };
    handler[HANDLER_MARKER] = true;
    window.PG_GIFT_NOTIFY_HANDLER = handler;
  }

  function scheduleDetection(delayMs) {
    if (detectTimer) clearTimeout(detectTimer);
    detectTimer = setTimeout(processGiftData, Math.max(0, Number(delayMs) || 0));
  }

  function initDetection() {
    observeCartDrawerForToastLayout();
    observeGiftDataMutations();
    registerGiftNotifyHandler();

    // Seed baseline from Liquid-rendered cart state without showing toast.
    var initialItems = readGiftDataFromDOM();
    if (initialItems !== null) {
      detectNewGifts(initialItems, false);
      debugLog('Init with initialItems', initialItems);
    } else {
      debugLog('Init without initialItems');
    }

    function scheduleFromCartEvent(event, sourceName) {
      hasSeenCartSignal = true;
      var replacementDelay = event && event.detail && Number(event.detail.replacementDelay);
      var detectDelay = isNaN(replacementDelay) ? DETECT_DEBOUNCE_MS : replacementDelay + 100;
      debugLog(sourceName + ' received', {
        replacementDelay: replacementDelay,
        detectDelay: detectDelay,
        detail: event && event.detail
      });
      scheduleDetection(detectDelay);
    }

    // Primary source used across theme scripts.
    document.documentElement.addEventListener('cart:refresh', function (event) {
      scheduleFromCartEvent(event, 'cart:refresh');
      setTimeout(syncVisibleToastOffset, 400);
    });
    document.addEventListener('cart:refresh', function (event) {
      scheduleFromCartEvent(event, 'cart:refresh(document)');
    });
    window.addEventListener('cart:refresh', function (event) {
      scheduleFromCartEvent(event, 'cart:refresh(window)');
    });

    // Fallback native cart events in case a flow skips cart:refresh.
    document.addEventListener('cart:updated', function (event) {
      scheduleFromCartEvent(event, 'cart:updated');
    });

    document.addEventListener('line-item-quantity:change:end', function (event) {
      scheduleFromCartEvent(event, 'line-item-quantity:change:end');
    });

    window.addEventListener('scroll', syncVisibleToastOffset, { passive: true });
    window.addEventListener('resize', syncVisibleToastOffset);

    // Console debug helpers (safe, read-only)
    window.PGFreeGiftToastDebug = {
      enabled: DEBUG_ENABLED,
      enable: function () {
        try { localStorage.setItem(DEBUG_FLAG_KEY, '1'); } catch (e) {}
        console.log('[PG Free Gift Toast] Debug enabled. Reload page.');
      },
      disable: function () {
        try { localStorage.removeItem(DEBUG_FLAG_KEY); } catch (e) {}
        console.log('[PG Free Gift Toast] Debug disabled. Reload page.');
      },
      readGiftDataFromDOM: readGiftDataFromDOM,
      processGiftData: processGiftData,
      getPreviousGiftKeys: function () { return Array.from(previousGiftKeys); },
      showTestToast: function () {
        showFreeGiftToast([{
          key: 'debug-gift',
          product_title: 'Debug Gift',
          image: '',
          featured_image: { url: '' }
        }]);
      },
      readGiftDataFromLineItems: readGiftDataFromLineItems
    };
    debugLog('Debug helper ready: window.PGFreeGiftToastDebug');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDetection);
  } else {
    initDetection();
  }
})();
